var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageSvhSeven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 184,
    viewBox: "0 0 255 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1102_4994)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5123 5C22.602 5 17 10.602 17 17.5123V36.5372L4.7668 36.5372C4.10985 36.5372 3.75914 37.3269 4.1874 37.8418L17 53.2486V165.488C17 172.398 22.6019 178 29.5123 178H235.488C242.398 178 248 172.398 248 165.488V17.5123C248 10.602 242.398 5 235.488 5H29.5123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 36.5372L17 37.7102H18.173V36.5372H17ZM4.7668 36.5372L4.76679 37.7102H4.76679L4.7668 36.5372ZM4.1874 37.8418L3.28549 38.5919L3.28549 38.5919L4.1874 37.8418ZM17 53.2486H18.173V52.8246L17.9019 52.4986L17 53.2486ZM18.173 17.5123C18.173 11.2498 23.2498 6.17303 29.5123 6.17303V3.82697C21.9541 3.82697 15.827 9.95411 15.827 17.5123H18.173ZM18.173 36.5372V17.5123H15.827V36.5372H18.173ZM4.76679 37.7102L17 37.7102L17 35.3642L4.7668 35.3641L4.76679 37.7102ZM5.0893 37.0918C5.18571 37.2077 5.19048 37.3638 5.14222 37.4725C5.09279 37.5838 4.95505 37.7102 4.76679 37.7102L4.7668 35.3641C3.04035 35.3641 2.27044 37.3713 3.28549 38.5919L5.0893 37.0918ZM17.9019 52.4986L5.0893 37.0918L3.28549 38.5919L16.0981 53.9986L17.9019 52.4986ZM18.173 165.488V53.2486H15.827V165.488H18.173ZM29.5123 176.827C23.2498 176.827 18.173 171.75 18.173 165.488H15.827C15.827 173.046 21.9541 179.173 29.5123 179.173V176.827ZM235.488 176.827H29.5123V179.173H235.488V176.827ZM246.827 165.488C246.827 171.75 241.75 176.827 235.488 176.827V179.173C243.046 179.173 249.173 173.046 249.173 165.488H246.827ZM246.827 17.5123V165.488H249.173V17.5123H246.827ZM235.488 6.17303C241.75 6.17303 246.827 11.2498 246.827 17.5123H249.173C249.173 9.95411 243.046 3.82697 235.488 3.82697V6.17303ZM29.5123 6.17303H235.488V3.82697H29.5123V6.17303Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1102_4994",
    x: -3.42486,
    y: -2.42913,
    width: 258.854,
    height: 187.858,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.12808
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.365319 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1102_4994"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1102_4994",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSvhSeven);
export default __webpack_public_path__ + "static/media/message_svh_seven.a35b86cd624a20b066625d2ff09d047a.svg";
export { ForwardRef as ReactComponent };